import { find } from 'lodash-es';
import { CommonState, ItemsMap } from '@/common/store/modules/common/types/CommonState';
import { ActionsArgs } from '@/common/store/modules/common/types/ActionArgs';
import { CommonRequestView } from '@/common/store/modules/common/types/CommonRequestView';
import { DEFAULT_REQUEST_VIEW } from './common.constants';

const createGetters = <ModelType>(options: ActionsArgs<ModelType>): CommonGetterTree<CommonState> => ({
  options: (): ActionsArgs<ModelType> => options,
  errors: state => state.errors as object,
  _mapItem: state => (id: ID): ItemsMap => state.itemsMap[id],
  isLoading: (_state, getters): boolean => getters.getRequestView().loading,
  isLastPage: (_state, getters): boolean => getters.getRequestView().isLastPage,
  marker: (_state, getters): ID => getters.getRequestView().marker,
  getCount: (_state, getters): number => getters.getRequestView().count ?? getters.getItems.length,
  getItems: (_state, getters): ModelType[] => getters.getRequestView().list.map(id => getters.getItemById(id)),
  getItemsByView: (_state, getters): (view: CommonRequestView) => ModelType[] => (view: CommonRequestView) => getters.getRequestView(view).list?.map(id => getters.getItemById(id)),
  getRequestView: state => (view = DEFAULT_REQUEST_VIEW): CommonRequestView => state.viewLists[view] || {},
  // eslint-disable-next-line no-underscore-dangle
  getItemById: (_state, getters) => (id: ID): ItemsMap => getters._mapItem(id),
  getItemsByIds: (state, getters): (ids: ID[]) => ModelType[] => (ids: ID[]): ModelType[] => state.viewLists[DEFAULT_REQUEST_VIEW].list?.filter(id => ids.includes(id))
  .reduce((obj, key) => ({
    ...obj,
    [key]: getters.getItemById(key)
  }), {}),
  getItemsByProp: (_state, getters): (prop: string) => (value: unknown) => ModelType[] => (prop: string) => (value: unknown) => getters.getItems.filter(item => item[prop] === value),
  getItemsWithProp: (_state, getters): (prop: string) => ModelType[] => (prop: string): ModelType[] => getters.getItems.filter(item => item[prop]),
  getItemByProp: (_state, getters): (prop: string) => (value: unknown) => any => (prop: string) => (value: unknown) => getters.getItems.find(item => item[prop] === value),
  findItemByProps: (_state, getters): ({ index, ...props }: { index: number; [p: string]: any }) => any => ({ index, ...props }) => index !== undefined
  ? getters.getItems[index]
  : find(getters.getItems, props)
});

export default createGetters;
